import React, { FC } from 'react';
import { ChatHeart, Flower1, Lock, SunriseFill } from 'react-bootstrap-icons';
import { Faq, FaqItem, FictionalIcon, HeroImage } from '../../customFrontend/parts';
import { SiteManifest, SiteManifestPage } from '../../customFrontend/types';
import { CityTiles, Cta, SiteFooter } from './Chrome';

const FAQ: FaqItem[] = [
  {
    q: 'What does MatureFlirt cost?',
    a: <p>Creating your profile is free, and so are your first messages. From then on, messages, flirts and photos are paid with credits. Packages are optional and the price of each is shown before you buy.</p>,
  },
  {
    q: 'Is a card needed to register?',
    a: <p>No. Signing up never asks for card details. You choose a nickname and can start chatting straight away.</p>,
  },
  {
    q: 'What do "MILF" and "cougar" mean here?',
    a: <p>They are affectionate terms for attractive women in their forties, fifties and beyond, and a cougar usually enjoys the company of younger men. On MatureFlirt they describe the confident, experienced women the site is built around.</p>,
  },
  {
    q: 'Are the profiles real?',
    a: <p>No. MatureFlirt uses fictional profiles whose purpose is flirting with users. Each one shows a person icon <FictionalIcon />, and physical contact with them is not possible.</p>,
  },
  {
    q: 'Is MatureFlirt a dating site?',
    a: <p>No. It is a flirt chat for entertainment, not a place to arrange meetings or dates. Because the profiles are fictional, physical contact is not possible.</p>,
  },
  {
    q: 'Who is it for?',
    a: <p>Adults only: you must be at least 18. Men of any age are welcome, whether you are 25 and curious about an older woman or 60 and prefer someone your own generation.</p>,
  },
];

const Home: FC<{ site: SiteManifest; page: SiteManifestPage }> = ({ site, page }) => (
  <>
    <section className="mf-hero mf-hero--home">
      <div className="container">
        <figure className="mf-hero-photo">
          <HeroImage page={page} className="mf-hero-img" />
        </figure>
        <div className="mf-hero-card">
          <p className="mf-eyebrow">MILF &amp; cougar chat for Australia · 18+</p>
          <h1>
            Mature chat with <strong>confident women</strong>
          </h1>
          <p className="mf-lead">
            MatureFlirt is an Australian flirt chat built around experienced, self-assured women and the men who
            enjoy their company. Join free, send your first messages free, and let a sunny conversation get a
            little warmer.
          </p>
          <Cta>Join MatureFlirt free</Cta>
          <p className="mf-fineprint">No card to sign up · First messages free · Nickname only</p>
        </div>
      </div>
    </section>

    <section className="mf-section">
      <div className="container mf-narrow">
        <h2>Flirting with experience</h2>
        <p>
          Some of the best conversations happen with someone who has nothing left to prove. MatureFlirt is an online
          flirt and sex chat for adults in Australia, dedicated to mature women: MILFs, cougars and women who simply
          know their own minds. You create a profile under a nickname, browse, exchange messages, flirts and photos,
          and play Match, our daily swipe game.
        </p>
        <p>
          It is entertainment, not matchmaking. The profiles on MatureFlirt are fictional and are there to flirt with
          you; every one is marked with a person icon, and nobody on the site is offering to meet. What you get is
          witty, grown-up chat whenever you feel like it.
        </p>
      </div>
    </section>

    <section className="mf-section mf-section--sand">
      <div className="container">
        <h2 className="text-center">How MatureFlirt works</h2>
        <ol className="mf-steps">
          <li>
            <h3>Sign up in a minute</h3>
            <p>Pick a nickname and tell us who you would like to chat with. Registration is free.</p>
          </li>
          <li>
            <h3>Start with free messages</h3>
            <p>Your first messages cost nothing, so you can say hello, send a flirt and see who answers.</p>
          </li>
          <li>
            <h3>Carry on with credits</h3>
            <p>Afterwards, messages, flirts and photos use credits. Every price is listed on the prices page before you pay.</p>
          </li>
        </ol>
      </div>
    </section>

    <section className="mf-section">
      <div className="container">
        <h2 className="text-center">Why mature chat suits Australia</h2>
        <div className="mf-reasons">
          <div className="mf-reason">
            <SunriseFill aria-hidden="true" />
            <h3>Warm, not wild</h3>
            <p>Mature women flirt with humour and self-assurance. Conversations are relaxed, teasing and easy to enjoy.</p>
          </div>
          <div className="mf-reason">
            <ChatHeart aria-hidden="true" />
            <h3>Talk comes first</h3>
            <p>There is no rush here. A good question and a genuine reply go further than any line.</p>
          </div>
          <div className="mf-reason">
            <Lock aria-hidden="true" />
            <h3>Discreet from day one</h3>
            <p>A nickname is all anyone sees. Nothing is posted to social media, and you control your emails.</p>
          </div>
          <div className="mf-reason">
            <Flower1 aria-hidden="true" />
            <h3>Honest about itself</h3>
            <p>Strictly 18+, clear prices and fictional profiles marked with a person icon on every one.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="mf-section mf-section--sand">
      <div className="container">
        <h2 className="text-center">Mature chat in Australia&apos;s ten largest cities</h2>
        <p className="mf-section-intro">From the harbour to the Indian Ocean, each city with its own kind of charm.</p>
        <CityTiles />
      </div>
    </section>

    <section className="mf-section">
      <div className="container mf-narrow">
        <Faq title="Questions about MatureFlirt" items={FAQ} />
      </div>
    </section>

    <section className="mf-final">
      <div className="container">
        <h2>Confidence is attractive</h2>
        <p>Make your free profile and send the first message today.</p>
        <Cta light>Create my free profile</Cta>
      </div>
    </section>

    <SiteFooter site={site} />
  </>
);

export default Home;
